import { render } from "./tech-landing-page.vue?vue&type=template&id=5338caf6&scoped=true&ts=true"
import script from "./tech-landing-page.vue?vue&type=script&lang=ts"
export * from "./tech-landing-page.vue?vue&type=script&lang=ts"

import "./tech-landing-page.vue?vue&type=style&index=0&id=5338caf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5338caf6"]])

export default __exports__